import React, { Component } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Input,
  Label,
  Form,
  FormGroup,
  Collapse,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import MaterialTable from "material-table";
import moment from "moment";

import "../../assets/scss/components/MeterialTable/index.scss";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import InputText from "../InputText";
import CustomDatepicker from "../CustomDatepicker";

import history from "../../history";
import CartTitle from "../CartTitle";
import CustomButton from "../CustomButton";
import Loader from "../Loader";
import get from "lodash/get";

import RidesMembershipDetailPopup from "../RiderMembershipDetailPopup";
import "../../assets/scss/components/InputText/index.scss";

const _ = { get };

export default class RideMembershipList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      toggleActive: true,
      toggleCollapse: false,
      page: 0,
      phone: "",
      email: "",
      count: 100,
      status: "PENDING",
      pageSize: 10,
      startDate: new Date("04/01/2021"),
      endDate: new Date().setFullYear(new Date().getFullYear()),
      exportEmail: "",
      firstName: "",
      toggleDetail: false,
      rowData: null,
      toggleModal: false,
      selectedId: "",
      guid: "",
      vehicleId: "",
      vin: "",
    };
  }
  componentWillMount() {
    this.props.handleClearPreviousReducer();
    window.sessionStorage.removeItem("member");
    window.sessionStorage.removeItem("prevFlag");
  }

  componentDidMount() {
    let state = this.state;
    let data = {
      status: "PENDING",
      page: state.page,
      phone: state.phone,
      email: state.email,
      count: state.count,
      startDate: moment(this.state.startDate).format("DD/MM/YYYY"),
      endDate: moment(this.state.endDate).format("DD/MM/YYYY"),
      firstName: state.firstName,
      vin: state.vin,
    };
    this.props.handleFetchAllRideMembership(data);
    if (window !== "undefined") {
      window.scrollTo(0, 0);
    }
  }

  // componentDidUpdate(prevProps, prevState) {
  //   if (
  //     prevProps.ridesMembership.length !== this.props.ridesMembership.length
  //   ) {
  //     let state = this.state;
  //     state.page = Math.ceil(
  //       this.props.ridesMembership.length / this.state.count
  //     );
  //     this.setState({ ...state });
  //   }
  // }

  handleOnChangePageSize = (count) => {
    let state = this.state;
    state.pageSize = count;
    this.setState({ ...state });
  };

  handleOnPageChange = (e, page) => {
    let totalPages = this.props.ridesMembership.length / this.state.pageSize;
    let fetchNextData =
      e >= totalPages - 2 &&
      this.props.ridesMembership.length !== 0 &&
      this.props.ridesMembershipStatus === false &&
      this.props.ridesMembership.length < this.props.ridesMembershipCount;

    if (fetchNextData === true) {
      let obj = {
        page: this.state.page,
        count: this.state.count,
        status: this.state.status,
        email: this.state.email,
        phone: this.state.phone,
        firstName: this.state.firstName,
        startDate:
          this.state.startDate !== ""
            ? moment(this.state.startDate).format("DD/MM/YYYY")
            : "",
        endDate:
          this.state.endDate !== ""
            ? moment(this.state.endDate).format("DD/MM/YYYY")
            : "",
        vin: this.state.vin,
      };
      this.props.handleFetchAllRideMembership(obj);
    }
  };

  handleFilterChange = (e, id) => {
    let state = this.state;
    if (id === "email") {
      state[e.target.name] = e.target.value;
      this.setState({ ...state });
    }
    if (id === "phone") {
      state[e.target.name] = e.target.value;
      this.setState({ ...state });
    }
    if (id === "vin") {
      state[e.target.name] = e.target.value;
      this.setState({ ...state });
    }
  };

  handleFilterDates = (date, id) => {
    let state = this.state;
    if (id === "start") {
      state.startDate = date;
      state.endDate = "";
      this.setState({ ...state });
    }
    if (id === "end") {
      state.endDate = date;
      this.setState({ ...state });
    }
  };

  handleToggle = (e) => {
    let state = this.state;
    state.toggleActive = !state.toggleActive;
    if (state.toggleCollapse === true) {
      state.toggleCollapse = !state.toggleCollapse;
      this.setState({ ...state });
    }
    this.setState({ ...state });
  };

  handleToggleDetail = (e, rowData) => {
    let state = this.state;
    state.toggleDetail = !state.toggleDetail;
    state.rowData = rowData;
    this.setState({ ...state });
  };

  handleToggleIcon = (e) => {
    let state = this.state;
    state.toggleCollapse = !state.toggleCollapse;
    if (state.toggleActive === true) {
      state.toggleActive = !state.toggleActive;
      this.setState({ ...state });
    }

    this.setState({ ...state });
  };

  handleChangeStatus = (e) => {
    let state = this.state;
    state.status = e.target.value;
    this.setState({ ...state });
  };

  handleToggleModel = (e) => {
    let newState = { ...this.state };
    newState.toggleModal = !newState.toggleModal;
    this.setState({ ...newState });
  };

  handleRowData = (rowData) => {
    console.log("Checking rowdata", rowData);
    let newState = { ...this.state };
    newState.selectedId = rowData._id;
    newState.guid = rowData.userGUID;
    newState.toggleModal = !newState.toggleModal;
    newState.vehicleId = rowData.userID && rowData.userID._id;
    this.setState({ ...newState });
  };

  handleExportData = (e) => {
    let state = this.state;
    let { elements } = this.props;
    let obj = {
      email: state.exportEmail,
      firstName: state.firstName,
      startDate: "",
      endDate: "",
      moderationStatus: state.status,
    };
    if (state.exportEmail === "")
      return toast.error(
        _.get(
          elements,
          "userMembershipListingFilterElements.emailValidationElement",
          "Email cannot be empty"
        )
      );
    return this.props.handleExportToExcel(obj);
  };

  handleApproveRide = (data) => {
    let state = this.state;
    let obj = {
      page: 0,
      status: state.status,
      phone: state.phone,
      email: state.email,
      count: state.count,
      firstName: state.firstName,
      startDate:
        this.state.startDate !== ""
          ? moment(state.startDate).format("DD/MM/YYYY")
          : "",
      endDate:
        this.state.endDate !== ""
          ? moment(state.endDate).format("DD/MM/YYYY")
          : "",
      vin: state.vin,
    };
    this.props.handleApproveRideMembership(data, obj);
  };

  handleSubmitFilter = (e) => {
    e.preventDefault();
    let state = this.state;
    let data = {
      page: 0,
      status: state.status,
      phone: state.phone,
      email: state.email,
      count: state.count,
      firstName: state.firstName,
      startDate:
        this.state.startDate !== ""
          ? moment(state.startDate).format("DD/MM/YYYY")
          : "",
      endDate:
        this.state.endDate !== ""
          ? moment(state.endDate).format("DD/MM/YYYY")
          : "",
      vin: state.vin,
    };

    if (
      state.status !== "PENDING" ||
      state.phone !== "" ||
      state.email !== "" ||
      state.count !== "" ||
      state.startDate !== "" ||
      state.endDate !== "" ||
      state.firstName !== "" ||
      state.vin !== ""
    ) {
      this.props.handleClearPreviousReducer();
      this.props.handleFetchAllRideMembership(data);
    }
  };

  handleClearFilter = () => {
    let state = this.state;
    state.page = 0;
    state.status = "PENDING";
    state.email = "";
    state.phone = "";
    state.count = "";
    state.startDate = "";
    state.endDate = "";
    state.firstName = "";
    state.vin = "";
    this.setState({ ...state });
    let data = {
      page: 0,
      status: "PENDING",
      phone: "",
      email: "",
      count: 100,
      startDate: "",
      endDate: "",
      firstName: "",
      vin: "",
    };
    this.props.handleClearPreviousReducer();
    this.props.handleFetchAllRideMembership(data);
  };

  render() {
    let { elements } = this.props;
    return (
      <React.Fragment>
        {this.props.ridesMembershipStatus !== false ? <Loader /> : null}
        {this.props.exportToExcelStatus !== false ? <Loader /> : null}
        <div className="userListing hideSearch">
          <Form onSubmit={this.handleSubmitFilter}>
            <Row>
              <Col sm={12}>
                <CartTitle
                  title={_.get(
                    elements,
                    "userMembershipListingFilterElements.headingElement",
                    "Riders Membership"
                  )}
                  Name={_.get(
                    elements,
                    "userMembershipListingFilterElements.filterButtonElement",
                    "Filter"
                  )}
                  handleToggle={() => this.handleToggle()}
                  iconClass={"hideexcel"}
                  customExcelClick={() => this.handleToggleIcon()}
                  textTitle={_.get(
                    elements,
                    "userMembershipListingFilterElements.totalCountElement",
                    "Total Count - "
                  )}
                  preRegisteredUserCount={this.props.ridesMembershipCount}
                />
              </Col>
              <Col sm={12}>
                <Collapse isOpen={this.state.toggleActive}>
                  <Card className="mb-3">
                    <CardBody>
                      <Row>
                        <Col lg={4}>
                          <InputText
                            labelName={_.get(
                              elements,
                              "userMembershipListingFilterElements.emailLabel",
                              "Email"
                            )}
                            inputType={"email"}
                            inputName={"email"}
                            InputClass={"inputText mb-0"}
                            inputPlaceholder={_.get(
                              elements,
                              "userMembershipListingFilterElements.emailPlaceholder",
                              "Email"
                            )}
                            customValue={this.state.email}
                            customOnChange={(e) =>
                              this.handleFilterChange(e, "email")
                            }
                          />
                        </Col>
                        <Col lg={4}>
                          <InputText
                            labelName={_.get(
                              elements,
                              "userMembershipListingFilterElements.mobileLabel",
                              "Phone Number"
                            )}
                            inputType={"number"}
                            inputName={"phone"}
                            InputClass={"inputText mb-0"}
                            inputPlaceholder={_.get(
                              elements,
                              "userMembershipListingFilterElements.mobilePlaceholder",
                              "Phone Number"
                            )}
                            customValue={this.state.phone}
                            customOnChange={(e) =>
                              this.handleFilterChange(e, "phone")
                            }
                          />
                        </Col>
                        {/* <Col lg={4}>
                          <InputText
                            labelName={_.get(
                              elements,
                              "userMembershipListingFilterElements.firstNameLabel",
                              "First Name"
                            )}
                            inputType={"text"}
                            inputName={"firstName"}
                            InputClass={"inputText mb-0"}
                            inputPlaceholder={_.get(
                              elements,
                              "userMembershipListingFilterElements.firstNamePlaceholder",
                              "First Name"
                            )}
                            customValue={this.state.firstName}
                            customOnChange={(e) => this.handleFilterChange(e,"firstName")}
                          />
                        </Col>  */}
                        <Col lg={4}>
                          <Label className="inputLabel">
                            {_.get(
                              elements,
                              "userMembershipListingFilterElements.statusLabel",
                              "Status"
                            )}
                          </Label>
                          <FormGroup className="inputWrpper customInputBox">
                            <Input
                              type="select"
                              name="City"
                              value={this.state.status}
                              className="w-100 customeSelectBtn"
                              onChange={this.handleChangeStatus}
                            >
                              <option value={"PENDING"}>
                                {_.get(
                                  elements,
                                  "userMembershipListingFilterElements.pendingElement",
                                  "Pending"
                                )}
                              </option>
                              <option value={"APPROVED"}>
                                {_.get(
                                  elements,
                                  "userMembershipListingFilterElements.approvedElement",
                                  "Approved"
                                )}
                              </option>
                              <option value={"REJECTED"}>
                                {_.get(
                                  elements,
                                  "userMembershipListingFilterElements.rejectedElement",
                                  "Rejected"
                                )}
                              </option>
                              <option value={"UNALLOCATED"}>
                                {_.get(
                                  elements,
                                  "userMembershipListingFilterElements.unallocatedElement",
                                  "Unallocated"
                                )}
                              </option>
                            </Input>
                          </FormGroup>
                        </Col>

                        <Col lg={4} className="mb-3">
                          <Label className="inputLabel">
                            {_.get(
                              elements,
                              "userMembershipListingFilterElements.startDateLabelElement",
                              "Start Date"
                            )}{" "}
                          </Label>

                          <CustomDatepicker
                            value={this.state.startDate}
                            customPlaceHolder={_.get(
                              elements,
                              "userMembershipListingFilterElements.startDatePlaceHolderElement",
                              "Select Start Date"
                            )}
                            handleDateChange={(e) =>
                              this.handleFilterDates(e, "start")
                            }
                            customShowMonthDropdown={true}
                            customShowYearDropdown={true}
                            customMaxDate={new Date()}
                            // customMinDate={new Date("04/01/2021")}
                          />
                        </Col>

                        <Col lg={4} className="mb-3">
                          <Label className="inputLabel">
                            {_.get(
                              elements,
                              "userMembershipListingFilterElements.endDateLabelElement",
                              "End Date"
                            )}
                          </Label>

                          <CustomDatepicker
                            value={this.state.endDate}
                            customPlaceHolder={_.get(
                              elements,
                              "userMembershipListingFilterElements.endDatePlaceHolderElement",
                              "Select End Date"
                            )}
                            handleDateChange={(e) =>
                              this.handleFilterDates(e, "end")
                            }
                            customShowMonthDropdown={true}
                            customShowYearDropdown={true}
                            customMinDate={this.state.startDate}
                            // customMaxDate={new Date()}
                            customDisable={
                              this.state.startDate === "" ? true : false
                            }
                          />
                        </Col>
                        <Col lg={4}>
                          <InputText
                            labelName={_.get(
                              elements,
                              "userMembershipListingFilterElements.vinElement",
                              "VIN"
                            )}
                            labelClass={"vinLabelCase"}
                            inputType={"text"}
                            customValue={this.state.vin}
                            inputName={"vin"}
                            InputClass={"inputText mb-0"}
                            inputPlaceholder="Enter VIN"
                            customOnChange={(e) =>
                              this.handleFilterChange(e, "vin")
                            }
                            customMaxLength={17}
                          />
                        </Col>
                      </Row>
                      <div className="d-flex justify-content-center justify-content-lg-end position-relative ">
                        <CustomButton
                          customType={"submit"}
                          name={_.get(
                            elements,
                            "userMembershipListingFilterElements.searchButtonElement",
                            "Search"
                          )}
                          customClass={"btn-outline-dark bg-none btnthemeColor"}
                          customDisable={
                            this.state.status !== "PENDING" ||
                            this.state.phone !== "" ||
                            this.state.email !== "" ||
                            this.state.count !== "" ||
                            this.state.startDate !== "" ||
                            this.state.endDate !== "" ||
                            this.state.firstName !== ""
                              ? false
                              : true
                          }
                        />
                        <CustomButton
                          customType={"button"}
                          name={_.get(
                            elements,
                            "userMembershipListingFilterElements.clearFilterButtonElement",
                            "Clear Filter"
                          )}
                          customClass={
                            "btn-outline-dark bg-none ml-2 btnthemeColor"
                          }
                          customClick={() => this.handleClearFilter()}
                          customDisable={
                            this.state.status !== "PENDING" ||
                            this.state.phone !== "" ||
                            this.state.email !== "" ||
                            this.state.count !== "" ||
                            this.state.startDate !== "" ||
                            this.state.endDate !== "" ||
                            this.state.firstName !== ""
                              ? false
                              : true
                          }
                        />
                      </div>
                    </CardBody>
                  </Card>
                </Collapse>
                <Collapse isOpen={this.state.toggleCollapse}>
                  <Card className="mb-3">
                    <CardBody>
                      <Row className="justify-content-start">
                        <Col lg={4}>
                          <InputText
                            labelName={_.get(
                              elements,
                              "userMembershipListingFilterElements.exportToExcelEmailLabel",
                              "Email"
                            )}
                            inputType={"email"}
                            inputName={"exportEmail"}
                            InputClass={"inputText mb-0"}
                            inputPlaceholder={_.get(
                              elements,
                              "userMembershipListingFilterElements.exportToExcelEmailPlaceholder",
                              "Email"
                            )}
                            customValue={this.state.exportEmail}
                            customOnChange={(e) =>
                              this.handleFilterChange(e, "email")
                            }
                          />
                        </Col>

                        <Col
                          lg={2}
                          className="d-flex align-items-center justify-content-start"
                        >
                          <div className="mt-2 pt-1">
                            <CustomButton
                              customType={"button"}
                              name={_.get(
                                elements,
                                "userMembershipListingFilterElements.exportToExcelButton",
                                "Export To Excel"
                              )}
                              customClass={
                                "btn-outline-dark bg-none btnthemeColor"
                              }
                              customClick={() => this.handleExportData()}
                            />
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Collapse>
              </Col>
            </Row>
          </Form>

          <Row>
            <Col sm="12">
              <div className="custom-m-table">
                <MaterialTable
                  title=""
                  columns={[
                    {
                      title: _.get(
                        elements,
                        "memberShipListingTableElements.nameElement",
                        "Name"
                      ),
                      field: "firstName",
                      render: (rowData) =>
                        `${rowData.firstName} ${rowData.lastName}`,
                    },
                    {
                      title: _.get(
                        elements,
                        "memberShipListingTableElements.membershipElement",
                        "Membership"
                      ),
                      field: "membership.category",
                    },
                    {
                      title: _.get(
                        elements,
                        "memberShipListingTableElements.branchElement",
                        "Branch"
                      ),
                      field: "branch.branchName",
                    },
                    {
                      title: _.get(
                        elements,
                        "memberShipListingTableElements.statusElement",
                        "Status"
                      ),
                      field: "moderationStatus",
                    },
                    {
                      title: _.get(
                        elements,
                        "memberShipListingTableElements.countryElement",
                        "County"
                      ),
                      field: "country",
                    },
                    {
                      title: _.get(
                        elements,
                        "memberShipListingTableElements.emailElement",
                        "Email"
                      ),
                      field: "email",
                    },
                    {
                      title: _.get(
                        elements,
                        "memberShipListingTableElements.phoneElement",
                        "Phone"
                      ),
                      field: "mobile",
                    },
                    {
                      title: _.get(
                        elements,
                        "memberShipListingTableElements.sourceElement",
                        "Source"
                      ),
                      field: "source",
                    },
                    {
                      title: _.get(
                        elements,
                        "memberShipListingTableElements.userTypeElement",
                        "User type"
                      ),
                      field: "userType",
                    },
                    {
                      title: _.get(
                        elements,
                        "memberShipListingTableElements.originDealerElement",
                        "Origin Dealer"
                      ),
                      field: "originDealer",
                      render: (rowData) =>
                        rowData.originDealer ? rowData.originDealer : "N/A",
                    },
                  ]}
                  data={this.props.ridesMembership}
                  options={{
                    actionsColumnIndex: -1,
                    search: false,
                    paging: true,
                    sorting: false,
                    pageSize: this.state.pageSize,
                    paginationType: "stepped",
                    initialPage: 1,
                    showFirstLastPageButtons: false,
                  }}
                  actions={[
                    {
                      icon: "assignment_ind",
                      tooltip: _.get(
                        elements,
                        "detailPageTooltipElement",
                        "Detail Page"
                      ),
                      onClick: (event, rowData) => this.handleRowData(rowData),
                    },
                  ]}
                  onChangeRowsPerPage={(e) => this.handleOnChangePageSize(e)}
                  onChangePage={(e, page) => this.handleOnPageChange(e, page)}
                  localization={{
                    body: {
                      emptyDataSourceMessage: (
                        <h6>
                          {_.get(
                            elements,
                            "memberShipListingTableElements.noRecordsFoundElement",
                            "No records to display"
                          )}
                        </h6>
                      ),
                    },
                    pagination: {
                      labelRowsSelect: _.get(
                        elements,
                        "customMaterialTableElement.labelRowsSelect",
                        "rows"
                      ),
                      previousTooltip: _.get(
                        elements,
                        "customMaterialTableElement.previousTooltip",
                        "previous"
                      ),
                      nextTooltip: _.get(
                        elements,
                        "customMaterialTableElement.nextTooltip",
                        "next"
                      ),
                    },
                    header: {
                      actions: _.get(
                        elements,
                        "memberShipListingTableElements.actionsElement",
                        "Actions"
                      ),
                    },
                  }}
                />
              </div>
            </Col>
          </Row>
          <Modal
            isOpen={this.state.toggleModal}
            toggle={this.handleToggleModel}
            backdrop={true}
            centered={true}
            size="xl"
            className="modal_main"
          >
            <ModalBody>
              <RidesMembershipDetailPopup
                handleFetchAllRideMembership={
                  this.props.handleFetchAllRideMembership
                }
                handleClearPreviousReducer={
                  this.props.handleClearPreviousReducer
                }
                handleExportToExcel={this.props.handleExportToExcel}
                ridesMembershipStatus={this.props.ridesMembershipStatus}
                ridesMembership={this.props.ridesMembership}
                ridesMembershipCount={this.props.ridesMembershipCount}
                exportToExcelStatus={this.props.exportToExcelStatus}
                query={this.props.query}
                elements={this.props.elements}
                handleFetchSingleRideMembership={
                  this.props.handleFetchSingleRideMembership
                }
                handleApproveRideMembership={this.handleApproveRide}
                handleUpdateVin={this.props.handleUpdateVin}
                singleRidesMembershipStatus={
                  this.props.singleRidesMembershipStatus
                }
                singleRidesMembership={this.props.singleRidesMembership}
                approvingRidesMembershipStatus={
                  this.props.approvingRidesMembershipStatus
                }
                consentFormStatus={this.props.consentFormStatus}
                consentForm={this.props.consentForm}
                motorCycleStatus={this.props.motorCycleStatus}
                motorCycle={this.props.motorCycle}
                motorCycleCountryStatus={this.props.motorCycleCountryStatus}
                motorCycleCountry={this.props.motorCycleCountry}
                handleFetchMotorCycle={this.props.handleFetchMotorCycle}
                handleVechicleOnboarding={this.props.handleVechicleOnboarding}
                handlePendingVehicleOnboarding={
                  this.props.handlePendingVehicleOnboarding
                }
                handleFetchUserVehicles={this.props.handleFetchUserVehicles}
                vechicleOnboardingStatus={this.props.vechicleOnboardingStatus}
                userVehicles={this.props.userVehicles}
                userVehiclesStatus={this.props.userVehiclesStatus}
                handleVehicleOnBoardingFromMemberShip={
                  this.props.handleVehicleOnBoardingFromMemberShip
                }
                selectedId={this.state.selectedId}
                guid={this.state.guid}
                vehicleId={this.state.vehicleId}
                page={this.state.page}
                count={this.state.count}
                status={this.state.status}
                email={this.state.email}
                phone={this.state.phone}
                firstName={this.state.firstName}
                startDate={this.state.startDate}
                endDate={this.state.endDate}
                vin={this.state.vin}
                handleToggleModel={this.handleToggleModel}
              />
            </ModalBody>
          </Modal>
        </div>
      </React.Fragment>
    );
  }
}
